import { useCallback, useMemo } from "react"
import { usePieGraphOption } from "./options"
import { usePieGraphModel } from "./model"
import { numericValueFormat, percentFormat } from "../../common"
import { useStackLegend } from "../../../components/stackLegend"

type usePieGraphRenderOptionProps<T> = {
	graphOption: ReturnType<typeof usePieGraphOption<T>>
	graphData: ReturnType<typeof usePieGraphModel<T>>
}
export const usePieGraphRenderOption = <T,>({
	graphOption: {
		valueDef
	},
	graphData
}: usePieGraphRenderOptionProps<T>) => {
	const percentFormatter = useCallback(
		(params: { name: string, percent: number }) => percentFormat(params.name, params.percent, 1),
		[]
	)
	const valueFormatter = useCallback(
		(value: number | string) => numericValueFormat(value, 1, valueDef?.unit),
		[valueDef]
	)
	
	const legend = useStackLegend()
	const series = useMemo(
		() => {
			const hasTotal = (graphData?.totalData?.length ?? 0) > 0 ? true : false
			const seriesList = [{
				type: 'pie',
				radius: ['0%', hasTotal ? '60%' : '85%'],
				center: ['40%', '50%'],
				label: {
					show: true,
					position: 'inside',
					formatter: percentFormatter
				},
				data: graphData?.data || []
			}]
			if (hasTotal) {
				seriesList.push({
					type: 'pie',
					radius: ['70%', '85%'],
					center: ['40%', '50%'],
					label: {
						show: true,
						position: 'inside',
						formatter: percentFormatter
					},
					data: graphData?.totalData || []
				})
			}
			return seriesList
		},
		[graphData, percentFormatter]
	)
	
	return {
		//animation: false,
		tooltip: {
			trigger: 'item',
			valueFormatter
		},
		grid: {
			left: 10,
			right: 10,
			top: 10,
			bottom: 10,
			containLabel: true
		},
		legend,
		series,
		textStyle: {
			fontFamily: 'Noto Sans JP,sans-serif',
		}
	}
}
